import { render } from "./MainMenuItem.vue?vue&type=template&id=325730f4&scoped=true&ts=true"
import script from "./MainMenuItem.vue?vue&type=script&lang=ts"
export * from "./MainMenuItem.vue?vue&type=script&lang=ts"

import "./MainMenuItem.vue?vue&type=style&index=0&id=325730f4&lang=scss&scoped=true"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-325730f4"]])

export default __exports__